import { buildCtaButton, buildHeadshotBlock, buildLinkResetHeader, buildSocialIconTd } from './shared';

export default (brand) => ({
  id: 3,
  name: 'Template #4',
  height: 190,
  params: [
    'name',
    'title',
    'address',
    'email',
    'mobile',
    'office',
    'website',
    'facebook',
    'instagram',
    'linkedin',
    'twitter',
    'meeting',
    'review',
    'hiring',
    'support',
    'account'
  ],
  source: `${buildLinkResetHeader({ text: brand.text })}

<table id="body" cellpadding="0" cellspacing="0" style="width: 520px;border-collapse: collapse;" width="520" border="0">
  <tr>
    <td valign="top" style="width: 142px;padding-right: 16px;padding-top: 10px;" width="142">
      <table cellpadding="0" cellspacing="0" style="width: 142px;" width="142" border="0">
        
          <tr>
            <td align="center">
${buildHeadshotBlock({ indent: 14, size: 132, borderWidth: 5, ovalStyleDims: 'height: auto; width: 132px;', primary: brand.primary })}
            </td>
          </tr>
        
        <tr>
          <td align="center" style="padding-top: 8px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
${buildSocialIconTd({ indent: 18, field: 'facebook', type: 'facebook', alt: 'facebook', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 18, field: 'instagram', type: 'instagram', alt: 'instagram', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 18, field: 'linkedin', type: 'linkedin', alt: 'linkedin', background: 'none', color: brand.primaryNoHash, radius: 4 })}
${buildSocialIconTd({ indent: 18, field: 'twitter', type: 'x', alt: 'twitter', background: 'none', color: brand.primaryNoHash, radius: 4 })}
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
    <td valign="top" style="width: 176px;padding-top: 10px;" width="176">
      <table cellpadding="0" cellspacing="0" style="width: 176px;" width="176" border="0">
        {% if name %}
          <tr>
            <td style="color: ${brand.text}; font-size: 24px; font-family: Helvetica, Arial, sans-serif; line-height: 30px; mso-line-height-rule: exactly;">
              <b>{{ name }}</b>
            </td>
          </tr>
        {% endif %}
        {% if title %}
          <tr>
            <td style="color: ${brand.text}; font-size: 12px; font-family: Helvetica, Arial, sans-serif; line-height: 20px; mso-line-height-rule: exactly;padding-bottom: 6px;">
              <b>{{ title }}</b>
            </td>
          </tr>
        {% endif %}
        {% if address %}
          <tr>
            <td valign="top" style="padding-top: 2px;">
              <table cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td valign="middle" style="width: 18px;padding-right: 5px;" width="18">
                    <img
                      src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=address&background=none&color=${brand.primaryNoHash}&size=18&radius=4"
                      alt="location"
                      style="width: 18px;height: 18px;display: block;border: 0;"
                      width="18"
                      height="18"
                    >
                  </td>
                  <td valign="middle" style="line-height: 18px;">
                    <span style="color: ${brand.text} !important; font-size: 11px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;">
                      {{ address }}
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        {% endif %}
        {% if email %}
          <tr>
            <td valign="top" style="padding-top: 2px;">
              <table cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td valign="middle" style="width: 18px;padding-right: 5px;" width="18">
                    <img
                      src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=email&background=none&color=${brand.primaryNoHash}&size=18&radius=4"
                      alt="email"
                      style="width: 18px;height: 18px;display: block;border: 0;"
                      width="18"
                      height="18"
                    >
                  </td>
                  <td valign="middle" style="line-height: 18px;">
                    <a
                      href="mailto:{{email}}"
                      style="color: ${brand.text} !important; font-size: 11px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                    >
                      {{ email }}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        {% endif %}
        {% if mobile %}
          <tr>
            <td valign="top" style="padding-top: 2px;">
              <table cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td valign="middle" style="width: 18px;padding-right: 5px;" width="18">
                    <img
                      src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=mobile&background=none&color=${brand.primaryNoHash}&size=18&radius=4"
                      alt="mobile"
                      style="width: 18px;height: 18px;display: block;border: 0;"
                      width="18"
                      height="18"
                    >
                  </td>
                  <td valign="middle" style="line-height: 18px;">
                    <a
                      href="tel:{{mobile}}"
                      style="color: ${brand.text} !important; font-size: 11px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                    >
                      {{ mobile }}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        {% endif %}
        {% if office %}
          <tr>
            <td valign="top" style="padding-top: 2px;">
              <table cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td valign="middle" style="width: 18px;padding-right: 5px;" width="18">
                    <img
                      src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=phone&background=none&color=${brand.primaryNoHash}&size=18&radius=4"
                      alt="phone"
                      style="width: 18px;height: 18px;display: block;border: 0;"
                      width="18"
                      height="18"
                    >
                  </td>
                  <td valign="middle" style="line-height: 18px;">
                    <a
                      href="tel:{{office}}"
                      style="color: ${brand.text} !important; font-size: 11px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                    >
                      {{ office }}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        {% endif %}
        {% if website %}
          <tr>
            <td valign="top" style="padding-top: 2px;">
              <table cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td valign="middle" style="width: 18px;padding-right: 5px;" width="18">
                    <img
                      src="{{sgcnameproto}}://{{sgcname}}/v3/icons?type=website&background=none&color=${brand.primaryNoHash}&size=18&radius=4"
                      alt="web"
                      style="width: 18px;height: 18px;display: block;border: 0;"
                      width="18"
                      height="18"
                    >
                  </td>
                  <td valign="middle" style="line-height: 18px;">
                    <a
                      href="{{ website }}"
                      style="color: ${brand.text} !important; font-size: 11px; font-family: Helvetica, Arial, sans-serif; font-weight: 500; text-decoration: none !important;"
                    >
                      {{ website }}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        {% endif %}
      </table>
    </td>
    <td valign="top" style="width: 170px;padding-left: 16px;" width="170">
      <table cellpadding="0" cellspacing="0" style="width: 170px;" width="170" border="0">
        <tr>
          <td style="padding-top: 6px;padding-bottom: 16px;">
            <a href="{{ website }}" target="_blank" style="text-decoration: none;display: inline-block;">
              <img
                src="${brand.logoUrl}"
                alt="Company logo"
                style="width: 170px;height: auto;display: block;border: 0;outline: none;"
                width="170"
              >
            </a>
          </td>
        </tr>
        <tr>
          <td style="padding-top: 8px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
${buildCtaButton({ indent: 18, width: 170, hrefToken: 'meeting', label: 'Schedule a Chat', fontSize: '10px', primary: brand.primary })}
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="padding-top: 8px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
${buildCtaButton({ indent: 18, width: 81, hrefToken: 'review', label: 'Review Us', fontSize: '9px', primary: brand.primary })}
                <td width="8" style="width:8px;">&nbsp;</td>
${buildCtaButton({ indent: 18, width: 81, hrefToken: 'hiring', label: "We're Hiring", fontSize: '9px', primary: brand.primary })}
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="padding-top: 8px;">
            <table cellpadding="0" cellspacing="0" border="0">
              <tr>
${buildCtaButton({ indent: 18, width: 81, hrefToken: 'support', label: 'Visit Support', fontSize: '9px', primary: brand.primary })}
                <td width="8" style="width:8px;">&nbsp;</td>
${buildCtaButton({ indent: 18, width: 81, hrefToken: 'account', label: 'My Account', fontSize: '9px', primary: brand.primary })}
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>`
});
